import type { GatsbyBrowser } from 'gatsby';
import './src/global.scss';
import React from 'react';
import NoteLayout from './src/components/NoteLayout';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
    // keep the component state in the layout when switching pages
    const isNotePage = props.pageResources.page.componentChunkName.includes('src-templates-note');
    return isNotePage ? <NoteLayout {...props}>{element}</NoteLayout> : <>{element}</>;
};
